<template>
  <div class="content">
    <div class="terms">
      <!-- <h1>{{ $t("message.privacy_policy_title") }}</h1> -->
      <p>{{ $t("message.privacy_policy_section0_content1") }}</p>
      <p>{{ $t("message.privacy_policy_section0_content2") }}</p>
      <p>{{ $t("message.privacy_policy_section0_content3") }}</p>
      <p>{{ $t("message.privacy_policy_section0_content4") }}</p>
      <h2>{{ $t("message.privacy_policy_section1_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section1_content1") }}</p>
      <h3>{{ $t("message.privacy_policy_section1_content2") }}</h3>
      <h4>{{ $t("message.privacy_policy_section1_content3") }}</h4>
      <p>{{ $t("message.privacy_policy_section1_content4") }}</p>
      <ul>
        <li>{{ $t("message.privacy_policy_section1_content5") }}</li>
      </ul>
      <h4>{{ $t("message.privacy_policy_section1_content6") }}</h4>
      <p>{{ $t("message.privacy_policy_section1_content7") }}</p>
      <p>{{ $t("message.privacy_policy_section1_content8") }}</p>
      <p>{{ $t("message.privacy_policy_section1_content9") }}</p>
      <h4>{{ $t("message.privacy_policy_section1_content10") }}</h4>
      <p>{{ $t("message.privacy_policy_section1_content11") }}</p>
      <p>{{ $t("message.privacy_policy_section1_content12") }}</p>
      <p>{{ $t("message.privacy_policy_section1_content13") }}</p>
      <h2>{{ $t("message.privacy_policy_section2_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section2_content1") }}</p>
      <ul>
        <li>{{ $t("message.privacy_policy_section2_content2") }}</li>
        <li>{{ $t("message.privacy_policy_section2_content3") }}</li>
        <li>{{ $t("message.privacy_policy_section2_content4") }}</li>
        <li>{{ $t("message.privacy_policy_section2_content5") }}</li>
        <li>{{ $t("message.privacy_policy_section2_content6") }}</li>
        <li>{{ $t("message.privacy_policy_section2_content7") }}</li>
        <li>{{ $t("message.privacy_policy_section2_content8") }}</li>
      </ul>
      <h2>{{ $t("message.privacy_policy_section3_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section3_content1") }}</p>
      <p>{{ $t("message.privacy_policy_section3_content2") }}</p>
      <p>{{ $t("message.privacy_policy_section3_content3") }}</p>
      <p>{{ $t("message.privacy_policy_section3_content4") }}</p>
      <h2>{{ $t("message.privacy_policy_section4_title") }}</h2>
      <h3>{{ $t("message.privacy_policy_section4_content1") }}</h3>
      <p>{{ $t("message.privacy_policy_section4_content2") }}</p>
      <ul>
        <li>{{ $t("message.privacy_policy_section4_content3") }}</li>
        <li>{{ $t("message.privacy_policy_section4_content4") }}</li>
        <li>{{ $t("message.privacy_policy_section4_content5") }}</li>
        <li>{{ $t("message.privacy_policy_section4_content6") }}</li>
        <li>{{ $t("message.privacy_policy_section4_content7") }}</li>
      </ul>
      <h2>{{ $t("message.privacy_policy_section5_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section5_content1") }}</p>
      <h2>{{ $t("message.privacy_policy_section6_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section6_content1") }}</p>
      <p>{{ $t("message.privacy_policy_section6_content2") }}</p>
      <h3>{{ $t("message.privacy_policy_section6_content3") }}</h3>
      <p>{{ $t("message.privacy_policy_section6_content4") }}</p>
      <ul>
        <li>
          <p><strong>{{ $t("message.privacy_policy_section6_content5") }}</strong></p>
          <p>{{ $t("message.privacy_policy_section6_content6") }}</p>
          <p>{{ $t("message.privacy_policy_section6_content7") }}</p>
        </li>
      </ul>
      <h2>{{ $t("message.privacy_policy_section7_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section7_content1") }}</p>
      <p>{{ $t("message.privacy_policy_section7_content2") }}</p>
      <h2>{{ $t("message.privacy_policy_section8_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section8_content1") }}</p>
      <p>{{ $t("message.privacy_policy_section8_content2") }}</p>
      <h2>{{ $t("message.privacy_policy_section9_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section9_content1") }}</p>
      <p>{{ $t("message.privacy_policy_section9_content2") }}</p>
      <p>{{ $t("message.privacy_policy_section9_content3") }}</p>
      <h2>{{ $t("message.privacy_policy_section10_title") }}</h2>
      <p>{{ $t("message.privacy_policy_section10_content1") }}</p>
      <ul>
        <li v-html='$t("message.privacy_policy_section10_content2")'></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {}

</script>
<style scoped lang="scss">
.content {
  padding-left: 1.5em;
  padding-right: 1.5em;
}

.terms {
  font-size: 0.9em;
  padding-top: 2em;
  padding-bottom: 3em;

  >ul {
    list-style-type: disc;
    margin-left: 2em;
  }

  >li {
    display: list-item;
  }
}

.terms h1 {
  padding-top: 50px;
  padding-bottom: 25px;
  font-size: 1.95em;
  font-weight: bold;
  color: #505050;
  text-align: center;
}

.terms h2 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-weight: bold;
  font-size: 1.1em;
  color: #505050;
}

.terms h3 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-weight: bold;
  font-size: 1.1em;
  color: #505050;
}

.terms h4 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-weight: bold;
  font-size: 1.0em;
  color: #666666;
}

.terms p {
  line-height: 1.8em;
  margin-bottom: 1em;
}

</style>
